<template>
  <div class="success-details">
    <div class="success-details-top">
      <Row>
        <Col span="2"></Col>
        <Col span="20">
          <div class="success-details-top-content">
            <h2>{{content[num].title1}}</h2>
            <p>{{content[num].wordP1}}</p>
            <div class="success-details-content">
              <div class="success-details-content-img">
                <img :src="content[num].pieceImg" width="100%"/>
              </div>
              <div class="success-details-content-word1">
                <p class="p1">客户名称</p>
                <p class="p2">{{content[num].pieceTitle}}</p>
                <!-- <p><span class="p1">客户名称</span><span class="p2">{{content[num].pieceTitle}}</span></p> -->
              </div>
              <div class="success-details-content-word2">
                <p class="p1">行业类型</p>
                <p class="p2">{{content[num].pieceWord}}</p>
                <!-- <p ><span class="p1">行业类型</span><span class="p2">{{content[num].pieceWord}}</span></p> -->
              </div>
            </div>
          </div>
        </Col>
        <Col span="2"></Col>
      </Row>

    </div>
    <div class="success-details-cent">
      <Row>
        <Col span="2"></Col>
        <Col span="20">
          <div class="success-details-cent-content">
            <h2>项目成果</h2>
            <p>{{content[num].wordP2}}</p>
            <p>{{content[num].wordP3}}</p>
            <p>{{content[num].wordP4}}</p>
            <p>{{content[num].wordP5}}</p>
            <p>{{content[num].wordP6}}</p>
            <p>{{content[num].wordP7}}</p>
            <p>{{content[num].wordP8}}</p>
            <p>{{content[num].wordP9}}</p>
            <p>{{content[num].wordP10}}</p>
			<div>
				<img :src="content[num].img" width="90%"/>
			</div>
			
          </div>
        </Col>
        <Col span="2"></Col>
      </Row>
    </div>
  </div>
</template>

<script>
  export default {
    data(){
      return {
        num:this.$route.query.num,
        content:{
          "0":{
            title1:"东阳光宜都工业园区智慧园区管理平台IT运维管理平台",
            wordP1:'以平台建设的模式对园区内外基础数据、业务资源进行整合和统一管理，建立园区数据中心，对园区管理数据进行抽取、清洗和转换，通过平台与信息化设备和园区各管理子系统的对接，实现业务数据全链路采集、信息化设备统一监管。建设园区车辆通行管理应用等，最终形成东阳光集团宜都工业园的现代化园区管理服务平台',
            wordP2:"1、建设了“智慧园区基础服务平台”、“园区数据中心数仓”和“智慧通行系统”",
            wordP3:"2、完成了智慧园区管理平台数字底座建设，实现了数据便捷采集和资产化管理",
            wordP4:"3、为数据二次挖掘应用奠定基础，实现了园区通行设施、设备统计管理和智慧化通行管理",
            wordP5:"4、奠定了坚实的园区信息化建设基础",
            wordP6:"5、提高了园区智能化水平和园区服务管理水平",
            wordP7:"",
            wordP8:"",
            wordP9:"",
            wordP10:"",
            pieceImg:require('../components/dyg.png'),
            pieceTitle:"宜昌东阳光长江药业股份有限公司",
            pieceWord:"研发、生产、销售国内外原料药、仿制药、生物药、首仿药、新药；销售胰岛素医疗器械",
			img:"",
          },
          "1":{
            title1:"金鹰重型工程机械股份有限公司综合管理平台",
            wordP1:'基于IT综合运维管理平台在金鹰重工的部署，及时掌控网络设备、服务器、应用系统及机房的可用性、可靠性和稳定性；及时、快速处理突发的故障和业务平台应用服务问题。更好的管理IT硬件设备及软件系统；提供一个高可用性、高可靠性和高稳定性的网络；快速处理突发的故障，做到防患于未然。从而实现人工排查耗时耗力运维现状到综合资源智能监控、快速响应的跨越。',
            wordP2:"建设一个整体的IT运维保障体系，为客户生产和业务的信息化基础环境提供安全稳定运行的保障:",
            wordP3:"1、建立完善的运维管理规范体系",
            wordP4:"2、建立定制化服务目录和服务级别协议管理",
            wordP5:"3、建立全面的综合运维门户",
            wordP6:"4、建立全面、准确、及时的基础监控系统",
            wordP7:"6、建立强力有效的安全管理系统",
            wordP8:"7、建立准确深度的性能管理系统",
            wordP9:"8、建立以IT资产库为核心，规范、智能的自动化运维系统",
            wordP10:"9、建立灵活、深度的统计分析系统",
            pieceImg:require('../../assets/img/jyC.png'),
            pieceTitle:"金鹰重型工程机械股份有限公司",
            pieceWord:"轨道工程装备产品的研发、生产、销售与维修业务",
			img:"",
          },
          "2":{
            title1:"宜昌山城水都冬虫夏草有限公司IT集成管理平台",
            wordP1:'建设IT集成管理平台搭建各生产相关组件、设备进行数字化模型，同时将辅助的应用系统和自动化生产设备统一接入并进行数据管理和统一监控，在平台中建立实时数据采集和告警分析机制，对各类型数据进行管理和关联，建立起厂区人员、设备、环境的全面感知体系，从而为厂区安全生产提供保障。',
            wordP2:"以“智能制造”为主导，将山城水都的厂区生产和经营打造成一个高度灵活的个性化和数字化的生产与服务模式体系：",
            wordP3:"1、实现统一的信息化集成管理平台",
            wordP4:"2、实现厂区全面数据自动采集分析",
            wordP5:"3、实现了综合运维管理体系",
            wordP6:"",
            wordP7:"",
            wordP8:"",
            wordP9:"",
            wordP10:"",
            pieceImg:require('../components/ycscsd.png'),
            pieceTitle:"宜昌山城水都冬虫夏草有限公司",
            pieceWord:"生产、研发、销售生态抚育冬虫夏草、鲜冬虫夏草",
			img:"",
          },
          "3":{
            title1:"中百仓储超市有限公司多媒体发布平台",
            wordP1:'以数字化、网络化、智能化的新型播放系统取代现行的广告机本地播放方式，设置网络化的多媒体信息发布系统，方便超市自行管理、自主控制媒体信息的组织和播放。',
            wordP2:"",
            wordP3:"1、建设中百仓储多媒体发布平台APP，提供下载页面、支持视频、图片、自动轮播、直播节目播放。",
            wordP4:"2、建设中百仓储多媒体发布平台管理平台，实现节目管理、素材分类、活动档期管理、供应商管理、功能区管理、门店管理、设备管理、品牌管理等功能模块。",
            wordP5:"",
            wordP6:"",
            wordP7:"",
            wordP8:"",
            wordP9:"",
            wordP10:"",
            pieceImg:require('../components/R-C.png'),
            pieceTitle:"中百仓储超市有限公司",
            pieceWord:"食品、生鲜、日用百货、家用电器、家居用品、文体用品、服装鞋帽",
			img:"",
          },
          "4":{
            title1:"宜昌市西陵区文体通",
            wordP1:'对全区文体资源进行线上统一整合，同时加强疫情期间全区文体业从业人员、游客管控。方便市民通过手机、平板电脑即可轻松找到在线培训、数字图书等“文化食粮”，随时搜索附近文体场馆，获取文体活动资讯，尽享“一站式”舒心文体服务。',
            wordP2:"",
            wordP3:"1、建设资源数据库，将区域内文体场馆等资源集中管理，记录访问、游览数据，为系统业务实现及未来扩展升级奠定基础。",
            wordP4:"2、建设文体通小程序，主要包含首页、信息浏览、个人中心三个部分组成。",
            wordP5:"3、建设文体通小程序后台，提供场馆管理、游客管理、票务管理、预约管理、课程安排、费用管理、统计分析功能。",
            wordP6:"4、建设文体通场馆大屏，实时展示当日进馆总人次、实时在馆人数、异常告警等，方便疫情期间游客分流管控。",
            wordP7:"5、健康码对接, 对接政数局健康码数据库。",
            wordP8:"",
            wordP9:"",
            wordP10:"",
            pieceImg:require('../components/xl.png'),
            pieceTitle:"宜昌市西陵区文化体育局",
            pieceWord:"组织实施非物质文化遗产保护和优秀民族文化的传承普及工作",
			img:"",
          },
          "5":{
            title1:"某市公安局大数据平台",
            wordP1:'按照市县两级大数据指挥服务中心、派出所勤务指挥室及各专业警种大数据可视化建设需求，利用全市各类公安业务和社会数据，运用数据地图方法和可视化展示技术，满足联合值守、情报研判、联合指挥、领导决策、数据查询等工作需要。',
            wordP2:"",
            wordP3:"1、建设网络设备管理模块，支持市场主流网络设备监控，通过多种算法自动发现网络拓扑图，支持多核心发现。支持基于资源模型的监控模式，对于不支持的网络设备用户可以自定义监控模型的方式来实现对新设备的支持。",
            wordP4:"2、对ip地址簿进行管理，支持ip地址管理和IP-MAC定位。",
            wordP5:"3、建设服务器主机及硬件监控，支持市场主流操作系统和服务器硬件的可视化监控。",
            wordP6:"4、建设统一告警管理，提供实时告警台，支持邮件、短信、桌面告警客户端通知功能。",
            wordP7:"5、建设专家系统，对各类IT资源的监控指标提供专业详尽解释，对各指标的异常告警提供故障解决的思路和办法。",
            wordP8:"",
            wordP9:"",
            wordP10:"",
            pieceImg:require('../components/gaj.png'),
            pieceTitle:"某市公安局",
            pieceWord:"公安机关",
			img:"",
          },
		  "6":{
		    title1:"枣阳市政务外网整体改造升级项目",
		    wordP1:'按照襄阳市已批复的政务外网技术方案要求，在现有政务基础设施网络基础上，升级改造电子政务外网，构建起连接全市各市直部门、镇（办、区）、二级单位和企事业单位、行政村（社区）四级的统一、安全、均衡、的电子政务外网基础网络平台，实现“一根网线通到底”，为下一步数字政府和智慧城市建设提供基础支撑。',
		    wordP2:"",
		    wordP3:"1、满足客户现阶段的融合需要，同时为今后的多网融合提供了完善的技术保障",
		    wordP4:"2、构建多级纵深防御体系，可实现全网安全集中管控",
		    wordP5:"3、提升威胁处置、实时监控、应急响应的能力，确保网络安全威胁可视、可管、可控",
		    wordP6:"",
		    wordP7:"",
		    wordP8:"",
		    wordP9:"",
		    wordP10:"",
		    pieceImg:"",
		    pieceTitle:"枣阳市行政审批局",
		    pieceWord:"公安机关",
			img:"",
		  },
		 //  "8":{
		 //    title1:"网络安全攻防演练项目",
		 //    wordP1:'黄石市XXX人民武装部响应国家网络安全的号召，联合武汉中安信通信息技术有限公司，执行《网络安全法》的要求，通过攻防演练的方式检验现有网络安全保障制度和应急指挥措施有效性、可靠性、实用性等，加强各地、各部门网络安全应急响应和处置熟练度，提高各部门应对各种网络安全突发事件的综合响应水平和应急处置能力。',
		 //    wordP2:"",
		 //    wordP3:"1、攻防对抗的场景是一个持续学习、持续改进的过程，冰冻三尺非一日之寒，在此次的攻防演练中，蓝队与红队共同学习，展示自己的技术能力，发展自己技术特长，通过这次严格规范取得实效。建立健全的网络安全现场应急处置管理体系。通过演练评价，提高了客户的网络安全意识、执行力意识和网络安全防护能力及应急处置能力。",
		 //    wordP4:"2、实战攻防演练保障工作将基于自适应安全架构的主动安保运营体系，建设积极防御的循环机制，实现由被动安全向主动安全的转化，确保护网时期信息系统的安全稳定运营。",
		 //    wordP5:"",
		 //    wordP6:"",
		 //    wordP7:"",
		 //    wordP8:"",
		 //    wordP9:"",
		 //    wordP10:"",
		 //    pieceImg:"",
		 //    pieceTitle:"某市人民武装部",
		 //    pieceWord:"公安机关",
			// img:"",
		 //  },
		  "8":{
		    title1:"襄阳市图书馆",
		    wordP1:'襄阳市图书馆总建筑面积约5.4万平方米，集藏、借、阅、管为一体，拥有纸质文献310万册（件）、音像资料2000余种，年订购中外文期刊5000多种。馆藏文献在文史古籍、自然科学、医学、外文权威检索期刊收藏上系统完整，具有特色。',
		    wordP2:"",
		    wordP3:"1、襄阳市图书馆投入了众多先进设备，让读者能通过“看、听、读、品”等多种参与和体验方式，触摸图书、体验科技、感受世界。",
		    wordP4:"2、利用移动互联网、物联网、5G、人工智能等信息技术为读者提供移动借阅、智能推送、智能导引等服务。",
		    wordP5:"3、各个借阅图书室均采用了智能自助借还书机,自助办证机和24H自助图书馆。",
		    wordP6:"",
		    wordP7:"",
		    wordP8:"",
		    wordP9:"",
		    wordP10:"",
		    pieceImg:"",
		    pieceTitle:"襄阳市图书馆",
		    pieceWord:"政府单位",
		 			img:"",
		  },
		  
		  "9":{
		    title1:"武汉图书馆",
		    wordP1:'武汉图书馆位于武汉市江汉区建设大道，是全国首批古籍重点保护单位、全国首批"数字图书馆推广工程"试点单位、全国社会科学普及基地，是湖北省"十佳图书馆"。武汉图书馆馆内无线网络全覆盖，配置有触摸屏检索机、阅报系统、电子书下载机、以及自助办证机、自助借还书机等自助服务设备，设置借阅合一阅览室、报刊借阅室、电子阅览室、地方文献阅览室、青少年阅览室、古籍阅览室等多个功能服务区17个。',
		    wordP2:"",
		    wordP3:"1、馆内实现了自助借还书机、自助办证机、安全门、点检车、馆员工作站等设备，与武汉市13个区馆及24小时自助图书馆实现通借通还。",
		    wordP4:"",
		    wordP5:"",
		    wordP6:"",
		    wordP7:"",
		    wordP8:"",
		    wordP9:"",
		    wordP10:"",
		    pieceImg:"",
		    pieceTitle:"武汉图书馆",
		    pieceWord:"政府单位",
		  		 			img:"",
		  },
			"10":{
			  title1:"北京冬奥会",
			  wordP1:'冬奥会开幕式舞台由地屏、冰立方、冰瀑和南北看台屏组成，全部由LED显示制成，总面积约14500平方米，利亚德提供了总面积约10000平米的LED屏幕，约占显示总面积的70%。开闭幕式运用的地屏是全世界最 大的LED屏幕，面积近11000平米，利亚德提供7000多平方米。包括开幕式的冰瀑、冰立方，以及鸟巢两侧实况转播屏也均由利亚德提供。',
			  wordP2:"",
			  wordP3:"1、利亚德克服多重困难，为北京冬奥会开闭幕工作的顺利开展提供了有力支撑。",
			  wordP4:"2、呈现了诸多视效解决方案，为全世界的观众留下了很多难忘的瞬间。",
			  wordP5:"3、北京冬奥会目前已圆满完成，相信在国家盛事面前，越来越多像利亚德这样的创新企业，将彰显出中国企业的责任与担当，更好展现出中国的科技实力。",
			  wordP6:"",
			  wordP7:"",
			  wordP8:"",
			  wordP9:"",
			  wordP10:"",
			  pieceImg:"",
			  pieceTitle:"2022北京冬奥会",
			  pieceWord:"政府单位",
			  img:"",
			},
			"11":{
			  title1:"第七届世界军人运动会闭幕式总制作",
			  wordP1:'“小间距”可谓是利亚德集团的杀手锏之一，这代表了显示产品的一项硬核技术。LED显示屏的小间距，也就是每一个小灯珠的间距，利亚德已经达到世界上最领先的0.6mm，意味着画面的分辨率和清晰度会大幅度提高，而国际上主流的技术基本是1.2mm。我们用自己的产品办世界的盛会，而且是世界领先的产品。闭幕式表演中所使用的投影、灯光、LED显示屏、音响等所有视效音效产品全部采用了利亚德提供的“中国制造”。这是利亚德送给世界的礼物，也是世界送给利亚德人最好的礼物，完美的开始，完美的结束',
			  wordP2:"",
			  wordP3:"",
			  wordP4:"",
			  wordP5:"",
			  wordP6:"",
			  wordP7:"",
			  wordP8:"",
			  wordP9:"",
			  wordP10:"",
			  pieceImg:"",
			  pieceTitle:"第七届世界军人运动会",
			  pieceWord:"政府单位",
			  img:require('../components/gxx.jpg'),
			},
			"12":{
			  title1:"献礼新中国成立70周年",
			  wordP1:'为庆祝新中国成立70周年，利亚德为庆典活动提供了1.4万平方米的多种类显示产品及显示系统。除为晚会表演现场提供特效支持外，在阅兵式现场，利亚德还提供了广场红飘带LED显示屏、阅兵指挥中心0.9毫米微间距显示屏、游行彩车车体显示产品等显示屏及集成系统服务。',
			  wordP2:"",
			  wordP3:"1、为庆祝新中国成立70周年，利亚德为庆典活动提供了1.4万平方米的多种类显示产品及显示系统。",
			  wordP4:"2、利亚德还提供了广场红飘带LED显示屏、阅兵指挥中心0.9毫米微间距显示屏、游行彩车车体显示产品等显示屏及集成系统服务。",
			  wordP5:"3、利亚德五千海内外员工将继续锐意创新、奋勇拼博，以优异的业绩打造享誉世界的中国品牌，为伟大祖国的繁荣富强贡献自己的才智和力量！",
			  wordP6:"",
			  wordP7:"",
			  wordP8:"",
			  wordP9:"",
			  wordP10:"",
			  pieceImg:"",
			  pieceTitle:"中国国庆70周年",
			  pieceWord:"政府单位",
			  img:"",
			},
       "7":{
         title1:"武汉体育学院校园网基础设施改造项目",
         wordP1:'学校于 2003 年开始建设校园网，采用传统以太网协议按照“核心--汇聚--接入”的三层网络架构进行建设。现有网络已经老化，学校决定在“十四五”期间对校园网基础设施进行全面的升级改造，进一步补充和完善校园弱电管网，实施“光纤入地”工程，基于 WiFi6 技术推进校园无线网络建设，逐步建成有线、无线网络全覆盖的新一代校园网，推进物联网建设，为学校数字校园建设及运行 提供高质量的网络支撑环境。 ',
         wordP2:"",
         wordP3:"1、初步建成覆盖全面、数量充足、安全可靠的校内通信光缆资源，为各通信网络建设提供主干网支撑，规范光缆资源管理。",
         wordP4:"2、东教学楼、西教学楼、图书馆等 3 栋教学楼宇及 9 至 12 栋等 4 栋学生宿舍实现校园网有线、无线网络全覆盖，满足广大师生在工作、学习、生活等各项活动中的用网需求，提供高质量的上网体验；完善楼宇内弱电管道设施，规范各类通信网络室内布线。",
         wordP5:"3、实现对哑终端设备入网的集中统一管理，为各类哑终端设备提供安全、可靠的网络接入环境，满足学校在教学、办公、科研等各项活动中对打印机等哑终端设备联网的需求。 ",
         wordP6:"4、实现建设范围内有线、无线信号全覆盖。无线网络应基于 WiFi6 技术，支持 802.11ax标准协议并向下兼容。",
         wordP7:"5、无线网络覆盖区域内应实现信号无盲区，信号接收强度不低于-65dBm，并支持多设备（无线 AP）间无缝漫游。",
         wordP8:"6、所有楼宇内单个房间须实现光纤入室，独享千兆带宽，保证用户上网体验。",
         wordP9:"7、建立物联网安全管控平台，实现对哑终端设备的可视化管理。通过策略配置，既可实现哑终端设备即插即用、无感准入，又可实现对哑终端设备入网可控。",
         wordP10:"",
         pieceImg:require('../components/se.png'),
         pieceTitle:"赛尔网络有限公司",
         pieceWord:"为用户提供包括网络接入、网络技术、网络信息等全方位的高品质服务。",
		 img:"",
       },
        }
      }
    }
  }

</script>

<style lang="less" scoped="scoped">
  .success-details{
    .success-details-top{
      background-size: 100% 100%;
      background-image: url(../../assets/img/banner2.png);
      background-repeat: no-repeat;
      padding-top: 1rem;

      .success-details-top-content{
        text-align: left;
		padding-left: 0.5rem;
        color: #ffffff;
        padding-bottom: 1rem;
        position: inherit;
        h2{
          margin-top: 1rem;
          margin-bottom: 0.2rem;
           font-family: SourceHanSansCN-Medium;
           font-size: 30px;
           font-weight: normal;
           font-stretch: normal;
           // line-height: 0px;
           letter-spacing: 0px;
           color: #ffffff;
        }
        p{
           font-family: MicrosoftYaHeiLight;
           font-size: 12px;
           font-weight: normal;
           font-stretch: normal;
           // line-height: 48px;
           letter-spacing: 0px;
           color: #ffffff;
          padding-right: 4.5rem;
        }
        .success-details-content{
          width: 4.3rem;
          height: 3.3rem;
          background-color: #ffffff;
          border-radius: 3%;
          position: absolute;
          top: 150px;
          right: 0.5rem;
          .success-details-content-img{
            padding: 0.5rem 0.5rem 0.2rem 0.5rem;
          }
          .success-details-content-word1{
            display: flex;
            padding: 0rem 0.5rem 0.2rem 0.5rem;
            .p1{
              flex: 1;
              padding-right: 0;
               font-family: SourceHanSansCN-Regular;
               font-size: 11px;
               font-weight: normal;
               font-stretch: normal;
               letter-spacing: 0px;
               color: #222222;
            }
            .p2{
              flex: 3;
              padding-right: 0;
               font-family: SourceHanSansCN-Light;
               font-size: 11px;
               font-weight: normal;
               font-stretch: normal;
               letter-spacing: 0px;
               color: #636d8b;
            }
          }
          .success-details-content-word2{
            display: flex;
            padding: 0rem 0.5rem 0.2rem 0.5rem;
            .p1{
              flex: 1;
              font-family: SourceHanSansCN-Regular;
              font-size: 11px;
              font-weight: normal;
              font-stretch: normal;
              letter-spacing: 0px;
              color: #222222;
              padding-right: 0;
            }
            .p2{
              flex: 3;
              color: #666666;
              padding-right: 0;
              font-family: SourceHanSansCN-Light;
              font-size: 11px;
              font-weight: normal;
              font-stretch: normal;
              letter-spacing: 0px;
              color: #636d8b;
            }
          }
        }
      }
    }
    .success-details-cent{
      text-align: left;
      padding-top: 0.5rem;
      padding-bottom: 1.5rem;
      background-color: #f4f5fa;
      .success-details-cent-content{
		padding-left: 0.5rem;
        padding-right: 5.5rem;
        h2{
           font-family: SourceHanSansCN-Regular;
           font-size: 24px;
           font-weight: normal;
           font-stretch: normal;
           // line-height: 0px;
           letter-spacing: 0px;
           color: #333333;
          margin-bottom: 0.2rem;
        }
        p{
           font-family: SourceHanSansCN-Light;
           font-size: 11px;
           font-weight: normal;
           letter-spacing: 0px;
           color: #253554;
          margin-bottom: 0.1rem;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/success-case-content/SuccessDetails.vue